import React from 'react';
import {IProduct} from 'data/interfaces/products';
import InfoCard from 'gui/pages/mainRouter/pages/ad/components/commons/infoCard';
import FlightIcon from '@material-ui/icons/Flight';
import FlightInfoSquare from './components/flightInfoSquare';

interface IFlightDetailsCardProps {
  product?: IProduct;
  style?: any;
  className?: string;
  title?: string;
}

const FlightDetailsCard = (props: IFlightDetailsCardProps) => (
  <InfoCard
    title={props.title ? props.title : ['פרטי הטיסה', `${props.product.ticketDetails.originAirport.city} - ${props.product.ticketDetails.destinationAirport.city}`].join(' - ')}
    icon={FlightIcon}
    toolTip="טיסה"
    style={props.style}
    defaultExpanded={true}
  >
    <FlightInfoSquare product={props.product}/>
  </InfoCard>
);

FlightDetailsCard.defaultProps = {};

export default React.memo(FlightDetailsCard);
